/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useContext, useImperativeHandle } from "react";
import { MeetingContext } from "@/pages/Meeting";
import style from "./style.module.scss";
// import { init } from "@/MeetingSDK/drafty";

interface VideoViewProps {
  peerId: string;
  videoTrack?: MediaStreamTrack;
  audioTrack?: MediaStreamTrack;
  // video?: boolean;
  // audio?: boolean;
  // local?: boolean;
  // share?: boolean;
}
const VideoView = React.forwardRef((props: VideoViewProps, ref: any) => {

  const { peerId, videoTrack, audioTrack } = props;
  const { isMonitorMode, videoFitMode } = useContext(MeetingContext);

  const videoRef = useRef<HTMLVideoElement>();

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (!videoTrack) {
      video.pause();
      video.srcObject = null;
      return;
    }

    const stream = new MediaStream([videoTrack]);
    console.log(`[VideoView] useEffect peerId=${peerId} videoTrack=${videoTrack}`);
    video.srcObject = stream;
    void video.play().catch((error) => {
      console.warn(`[VideoView] autoplay failed peerId=${peerId}`, error);
    });

    // 翻页或退订时断开旧 MediaStream，立即释放 Chrome 视频解码资源。
    return () => {
      if (video.srcObject === stream) {
        video.pause();
        video.srcObject = null;
      }
    };
  }, [peerId, videoTrack]);

    // Toggle Fullscreen for the video element
    const toggleFullScreen = () => {
      if (videoRef.current) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => console.log(err));
        } else {
          videoRef.current.requestFullscreen().catch((err) => console.log(err));
        }
      }
    };

  return (
    <>
      <video
        className={style.video}
        ref={videoRef}
        style={{
          opacity: videoTrack ? 1 : 0,
          objectFit: isMonitorMode ? videoFitMode : undefined,
        }}
        controls={false}
        autoPlay
        playsInline
        muted
        onDoubleClick={toggleFullScreen}
      />
    </>
  );
});

export default VideoView;
